/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiserviceMelcoModelsSelectListItem,
    ApiserviceMelcoModelsSelectListItemFromJSON,
    ApiserviceMelcoModelsSelectListItemFromJSONTyped,
    ApiserviceMelcoModelsSelectListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiserviceMelcoModelsDefaultAppSetting
 */
export interface ApiserviceMelcoModelsDefaultAppSetting {
    /**
     * 
     * @type {Array<ApiserviceMelcoModelsSelectListItem>}
     * @memberof ApiserviceMelcoModelsDefaultAppSetting
     */
    measurements?: Array<ApiserviceMelcoModelsSelectListItem> | null;
    /**
     * 
     * @type {Array<ApiserviceMelcoModelsSelectListItem>}
     * @memberof ApiserviceMelcoModelsDefaultAppSetting
     */
    emb_formats?: Array<ApiserviceMelcoModelsSelectListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsDefaultAppSetting
     */
    max_canvas_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsDefaultAppSetting
     */
    min_image_size?: number;
}

export function ApiserviceMelcoModelsDefaultAppSettingFromJSON(json: any): ApiserviceMelcoModelsDefaultAppSetting {
    return ApiserviceMelcoModelsDefaultAppSettingFromJSONTyped(json, false);
}

export function ApiserviceMelcoModelsDefaultAppSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiserviceMelcoModelsDefaultAppSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'measurements': !exists(json, 'measurements') ? undefined : (json['measurements'] === null ? null : (json['measurements'] as Array<any>).map(ApiserviceMelcoModelsSelectListItemFromJSON)),
        'emb_formats': !exists(json, 'emb_formats') ? undefined : (json['emb_formats'] === null ? null : (json['emb_formats'] as Array<any>).map(ApiserviceMelcoModelsSelectListItemFromJSON)),
        'max_canvas_size': !exists(json, 'max_canvas_size') ? undefined : json['max_canvas_size'],
        'min_image_size': !exists(json, 'min_image_size') ? undefined : json['min_image_size'],
    };
}

export function ApiserviceMelcoModelsDefaultAppSettingToJSON(value?: ApiserviceMelcoModelsDefaultAppSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'measurements': value.measurements === undefined ? undefined : (value.measurements === null ? null : (value.measurements as Array<any>).map(ApiserviceMelcoModelsSelectListItemToJSON)),
        'emb_formats': value.emb_formats === undefined ? undefined : (value.emb_formats === null ? null : (value.emb_formats as Array<any>).map(ApiserviceMelcoModelsSelectListItemToJSON)),
        'max_canvas_size': value.max_canvas_size,
        'min_image_size': value.min_image_size,
    };
}


